var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#73818E",
    fillRule: "evenodd",
    d: "M11.158 20v-2.356c2.857-.34 4.342-2.287 4.342-4.303 0-2.039-1.507-3.715-4.004-4.213l-.338-.068V4.417c1.373.385 2.048 1.563 2.182 2.423l2.025-.747c-.36-1.472-1.44-3.33-4.207-3.692V0H9.404v2.378c-2.52.317-4.297 2.152-4.297 4.304 0 2.22 1.44 3.646 3.735 4.122l.562.113v4.734c-1.777-.317-2.632-1.721-2.767-3.17L4.5 13.16c.247 1.993 1.777 4.167 4.904 4.484V20h1.754zM9.404 8.652c-1.53-.294-2.07-1.11-2.07-2.06 0-1.11.765-1.994 2.07-2.243v4.303zm1.754 7V11.28c1.463.34 2.138 1.223 2.138 2.174 0 1.042-.675 1.925-2.138 2.197z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSymbol);
export default __webpack_public_path__ + "static/media/dollar-symbol.69ddc90a.svg";
export { ForwardRef as ReactComponent };